<template>
  <div class="download_template">
    <el-dialog
      title="文档模板下载"
      :visible.sync="openDialog"
      width="700px"
      append-to-body
      :close-on-click-modal="false"
      class="dialog_title"
      @close="closeDialog"
    >
      <!-- 表单 -->
      <el-form
        :model="queryParams"
        ref="queryForm"
        :inline="true"
        label-width="70"
      >
        <el-form-item label="标题" prop="name">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入"
            clearable
            size="small"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="handleQuery"
            style="padding: 8px 20px"
            >查询</el-button
          >
          <el-button @click="resetQuery" size="small" style="padding: 8px 20px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>

      <el-table
        :data="postList"
        :header-cell-style="{
          background: '#F0F0F0',
          fontSize: '14px',
          height: '50px',
          fontWeight: 500,
          color: '#333',
        }"
      >
        <el-table-column label="ID" align="center" prop="id" />
        <el-table-column label="名称" align="center" prop="name" />

        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          width="180"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-tickets"
              @click="handleDownload(scope.row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { DomcumentTemplate } from "@/api/tearcher";
export default {
  data() {
    return {
      openDialog: false,
      queryParams: {
        name: "",
      },
      postList: [],
    };
  },
  methods: {
    //
    cancel() {
      this.openDialog = false;
    },
    isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (f) {
        return false;
      }

      return url.protocol === "http:" || url.protocol === "https:";
    },
    // 下载
    handleDownload(row) {
      if (!row.savepath || !this.isValidHttpUrl(row.savepath)) {
        this.messageTips("该文件暂无链接！", "error");
        return false;
      }

      window.open(row.savepath, "_blank"); // 新开窗口下载
    },
    operationDialog() {
      this.openDialog = true;
      this.getList();
    },
    closeDialog() {
      this.resetForm("queryForm");
    },
    // 文档模板
    getList() {
      DomcumentTemplate(this.queryParams).then((res) => {
        this.postList = res.data;
      });
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.getList();
    },
  },
};
</script>
 
<style lang = "less" scoped>
.download_template {
}
</style>